// let tabs = {
//   action: (el, tag, el_box) => {
//     let isActive = $(el).hasClass('active'),
//         box = $(el).closest(el_box);
//     $(tag+', .cont-tab').removeClass('active');

//     if($(el).closest('.cont-tab').length == 1) {
//       $("html, body").animate({ scrollTop: $(el).offset().top - 100 }, 500);

//       if ( !isActive ) { $('.cont-tab[data-name="'+$(el).attr('data-tab')+'"]').addClass('active'); $(el).addClass('active'); }
//     }else {
//       $('.cont-tab[data-name="'+$(el).attr('data-tab')+'"]', box).addClass('active');
//       $(el, box).addClass('active');
//     }
//   },
//   init: (prop) => {
//     $.each(prop, function(key, item) {
//       let box = item.box.toString(),
//           tag = item.tag.toString(),
//           $father = $(item.father.toString(), box);

//       if( typeof $(box) != "undefined" ) {
//         $(tag, $father).each(function(key,v) {
//           $(box).addClass('tabs-active');
//           $(v).attr('data-tab', 'tab_'+key);
//           $(v).before('<div class="cont-tab '+ (key == 0 ? "active": "") +'" data-name="tab_'+ key +'"><div class="contend"></div></div>');      
//           if($('>span',v).length == 0) {
//             let header = $(v).html();
//             $(v).text('').append("<span>"+header+"</span>");
//           }      
//           $('[data-name="tab_'+key+'"] .contend').before("<"+tag+">"+$(v).html()+"</"+tag+">");
//           $('[data-name="tab_'+key+'"] '+tag).attr('data-tab', 'tab_'+key);
//           if(key==0) {$(v).addClass('active');$('[data-name="tab_'+key+'"] '+tag).addClass('active')} 
//           $('~*',v).each(function(i,vn){        
//             if($(vn).is( tag )){
//               return false;
//             }else {
//               if($(' ~ .tabs', $father).length == 0){
//                 $father.after('<div class="tabs"></div>');
//               }
//               $('[data-name="tab_'+key+'"] .contend').append($(vn));          
//             }
//           });
//           $('.tabs').append($('[data-name="tab_'+key+'"]'));
//         })

//         $(tag).click(function(e) {
//           e.preventDefault();
//           tabs.action(this, tag, box);
//         });
//       }
//     })
//   },
//   run: (prop) => {
//     tabs.init(prop);
//   }
// };

// (function() {
//   tabs.run([{'box': '.ProductMeta__Description', tag: 'h5', father: '.Rte'}]);
// })();

// if ($('.SectionHeader__Heading').text().includes('Equipment')) {
//   $('.SectionHeader__Heading').next().css('max-width', 'unset');
// }

// $('.template-product .ProductMeta__Price .dualPrice').append('<span style="font-size: 0.7em; margin-left: .5rem;">excl. VAT</span>');
// $('.template-collection .ProductItem__Price .dualPrice').append('<span style="font-size: 0.7em; margin-left: .5rem;">excl. VAT</span>');

// $('.product-form__input').change(function(){
//   if ($('.ProductMeta__Price .dualPrice span').length < 1){
//     $('.template-product .ProductMeta__Price .dualPrice').append('<span style="font-size: 0.7em; margin-left: .5rem;">excl. VAT</span>');
//   }
// });

'use strict';

var tabs = {
  action: function action(el, tag, el_box) {
    var isActive = $(el).hasClass('active'),
        box = $(el).closest(el_box);
    $(tag + ', .cont-tab').removeClass('active');

    if ($(el).closest('.cont-tab').length == 1) {
      $("html, body").animate({ scrollTop: $(el).offset().top - 100 }, 500);

      if (!isActive) {
        $('.cont-tab[data-name="' + $(el).attr('data-tab') + '"]').addClass('active');$(el).addClass('active');
      }
    } else {
      $('.cont-tab[data-name="' + $(el).attr('data-tab') + '"]', box).addClass('active');
      $(el, box).addClass('active');
    }
  },
  init: function init(prop) {
    $.each(prop, function (key, item) {
      var box = item.box.toString(),
          tag = item.tag.toString(),
          $father = $(item.father.toString(), box);

      if (typeof $(box) != "undefined") {
        $(tag, $father).each(function (key, v) {
          $(box).addClass('tabs-active');
          $(v).attr('data-tab', 'tab_' + key);
          $(v).before('<div class="cont-tab ' + (key == 0 && item.activeFirst ? "active" : "") + '" data-name="tab_' + key + '"><div class="contend"></div></div>');
          if ($('>span', v).length == 0) {
            var header = $(v).html();
            $(v).text('').append("<span>" + header + "</span>");
          }
          $('[data-name="tab_' + key + '"] .contend').before("<" + tag + ">" + $(v).html() + "</" + tag + ">");
          $('[data-name="tab_' + key + '"] ' + tag).attr('data-tab', 'tab_' + key);
          if (key == 0 && item.activeFirst) {
            $(v).addClass('active');$('[data-name="tab_' + key + '"] ' + tag).addClass('active');
          }
          $('~*', v).each(function (i, vn) {
            if ($(vn).is(tag)) {
              return false;
            } else {
              if ($(' ~ .tabs', $father).length == 0) {
                $father.after('<div class="tabs"></div>');
              }
              $('[data-name="tab_' + key + '"] .contend').append($(vn));
            }
          });
          $('.tabs').append($('[data-name="tab_' + key + '"]'));
        });

        $(tag).click(function (e) {
          e.preventDefault();
          tabs.action(this, tag, box);
        });
      }
    });
  },
  run: function run(prop) {
    tabs.init(prop);
  }
};

$( document ).ready(()=>{
  tabs.run([{ 'box': '.ProductMeta__Description', tag: 'h5', father: '.Rte', activeFirst: true }])
  //collection.run()
  //product.run()
})

if ($('.SectionHeader__Heading').text().includes('Equipment')) {
  $('.SectionHeader__Heading').next().css('max-width', 'unset');
}

$('.template-product .ProductMeta__Price .dualPrice').append('<span class="Vat-info">excl. VAT</span>');
$('.template-collection .ProductItem__Price .dualPrice').append('<span class="Vat-info">excl. VAT</span>');

$('.product-form__input').change(function () {
  if ($('.ProductMeta__Price .dualPrice span').length < 1) {
    $('.template-product .ProductMeta__Price .dualPrice').append('<span class="Vat-info">excl. VAT</span>');
  }
});


let selectAdditionalCourses = {
  init: function(){
    $('.loader').hide();
    $('.select_additional_course').on('change', function(){
      if ($(this).val() == 'empty'){
        $('.additional_course_info').hide();
        return;
      }
      $('.additional_course_info').hide();
      $('.loader').css('display','flex');
      jQuery.post('/cart/add', {
        items: [{
          quantity: 1,
          id: $(this).val()
        }]
      }).done(() => {
        let productTitle = $('select.select_additional_course option:checked').attr('data-product-title');
        $('.loader').hide();
        $('.additional_course_info').fadeIn().html(`
          <p class="additional_course_info__text"><strong>${productTitle}</strong> has been added to your cart</p>
        `);
        setTimeout(function(){
          $('.ProductForm__AddToCart').trigger('click');
        }, 400);
      }).fail(() => {
        $('.loader').hide();
        $('.additional_course_info').fadeIn().html(`
          <p class="additional_course_info__text">Sorry, this product can't be added to your cart. Try again later.</p>
        `);
      });
    })

    if ($('.CartItem__Property').text().includes('Select additional courses') == false){
      console.log('inside');
      jQuery.post('/cart/update.js', {
        updates: {
          37570126872740: 0,
          37570093088932: 0,
          37570050621604: 0,
        }
      }).done(function(){
        location.reload()
      });
    }

    // jQuery.post('/cart/update.js', {
    //   updates: {
    //     37570126872740: 0
    //   }
    // }).done(() => window.location.reload());


    jQuery.ajax({
      dataType: 'json',
      url: '/products.json'
    }).done(function (productsRes) {
      console.log(productsRes);
      // productsRes.products.forEach((product, productIndex) => {
      //   if (product.tags.indexOf("produkt_promocyjny")) {
      //     console.log(product);
      //   };
      // });
    });

    var target = document.querySelector('.CartItem');
    var observer = new MutationObserver(function(mutations) {
      setTimeout(function(){
        if ($('.CartItem__Property').text().includes('Select additional courses') == false){
          // console.log('insideIF');
          jQuery.post('/cart/update.js', {
            updates: {
              37570126872740: 0,
              37570093088932: 0,
              37570050621604: 0,
            }
          });
          $('.CartItem').each(function(k,v){
            if ($('.CartItem__Title.Heading > a', $(v)).text().includes('Included')){
                // $(v).fadeOut('fast');
                window.location.reload();
            }
          })
        }
      }, 1100);
    });
    var config = {
      subtree: true,
      childList: true
    };
    observer.observe(document.body, config);

    



    $('.CartItem__Property').each(function(k,v){
      let additionalCourseId = Number($(v).text().substring(27))
      console.log(additionalCourseId)
    });

  },
  run: function(){
    selectAdditionalCourses.init();
  }
}


$( document ).ready(function() {

  selectAdditionalCourses.run();

  if($('.SectionHeader__Description.Rte .flexCenter').length > 0){
  	$('.SectionHeader__Description.Rte .flexCenter').insertBefore('.ProductListWrapper');
  }
  
  $('.Drawer__Container .SidebarMenu__Nav--secondary').insertBefore('.Drawer__Header button');
  $('.Drawer__Header .SidebarMenu__Nav--secondary a.Link').prepend(`<svg class="Icon Icon--account" role="presentation" viewBox="0 0 20 20">
      <g transform="translate(1 1)" stroke="#fff" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <path d="M0 18c0-4.5188182 3.663-8.18181818 8.18181818-8.18181818h1.63636364C14.337 9.81818182 18 13.4811818 18 18"></path>
        <circle cx="9" cy="4.90909091" r="4.90909091"></circle>
      </g>
    </svg>`);
  $('.Drawer__Header .SidebarMenu__Nav--secondary .Link.Text--subdued').addClass('Heading');
  
  if (window.location.href.includes('/collections/online-courses')){
    $('.Vat-info').css('display','none');
  }

  if ($('.ProductMeta__Description .Rte .hide-vat').length > 0){
    $('.Vat-info').css('display','none');
  }

});
